import { render, staticRenderFns } from "./approval.vue?vue&type=template&id=2ffb25e1&scoped=true"
import script from "./approval.vue?vue&type=script&lang=js"
export * from "./approval.vue?vue&type=script&lang=js"
import style0 from "./approval.vue?vue&type=style&index=0&id=2ffb25e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffb25e1",
  null
  
)

export default component.exports